/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import IframeEmbed from 'bundles/tutorials/components/IframeEmbed';

type Props = {
  src: string;
  title: string;
  description?: string;
};

const styles = {
  wrapper: css`
    margin: 24px 0;

    iframe {
      width: 100%;
      height: 500px;
      border: 1px solid black;
      border-radius: 4px;
      overflow: hidden;
    }
  `,
};

const CodeSandBox = ({ src, title, description }: Props) => {
  if (!src) {
    return null;
  }

  return (
    <div className="rc-CodeSandBox" css={styles.wrapper}>
      <IframeEmbed
        src={src}
        title={title}
        allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
        sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
      />
      {description && (
        <Typography2 variant="bodySecondary" component="p" color="supportText">
          {description}
        </Typography2>
      )}
    </div>
  );
};

export default CodeSandBox;
